export default {
  heading: "Login Information",
  accountSelect:{
    heading: "Please select the login information you want to change.",
    cityId:"Student Account",
    email:"Member",
  },
  thirdPartyAccount:{
    heading:  "Link your EdCity account with a third-party account",
    description:   "You may login to EdCity website with available third-party account options below.",
    connectInstruction: "Please click the icon(s) to link / unlink a third-party account.",
    connectReminder: "Color icon(s) is linked to your EdCity account. Black icon(s) is not linked to your EdCity account.",
    oauthCallback:{
      success: "Your third-party account has been successfully linked.",
      identifierUsed: "Failed. Your third-party account has been linked to another EdCity account.",
      userIdUsed: "Failed. Your EdCity account has been linked to another third-party account.",
      unknown: "Something went wrong, please try again later.",
      closeBtn: "Close",
      autoCloseMessagePre: "This window will close automatically in ",
      autoCloseMessagePost: " seconds."
    }
  }
};
